import React, { useEffect } from "react";
import "./Skills.css";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Skills() {
  useEffect(() => {
    AOS.init({
      useClassNames: true,
      initClassName: false,
      animatedClassName: "animated",
    });
  });
  return (
    <section id="Skills" class="skills-section">
      {/* <div class="container"></div> */}
      <h1 data-aos="fade-down">Tools And Skills</h1>

      <br></br>
      <br></br>
      <h2 data-aos="fade-down">Front-End</h2>
      <div class="skills-div">
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://web-strapi.mrmilu.com/uploads/flutter_logo_470e9f7491.png"
            alt=""
          />
          <h3>Flutter</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Dart_programming_language_logo_icon.svg/900px-Dart_programming_language_logo_icon.svg.png?20220708094811"
            alt=""
          />
          <h3>Dart</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://cdn1.iconfinder.com/data/icons/soleicons-fill-vol-1/64/reactjs_javascript_library_atom_atomic_react-512.png"
            alt=""
          />
          <h3>React Native</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png"
            alt=""
          />
          <h3>React js</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="data:image/png;base64,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"
            alt=""
          />
          <h3>Android Studio</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img src="https://cdn.svgporn.com/logos/javascript.svg" alt="" />
          <h3>JavaScript</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://cdn4.iconfinder.com/data/icons/tabler-vol-2/24/brand-kotlin-256.png"
            alt=""
          />
          <h3>Kotlin</h3>
        </div>

        <div class="skills-card" data-aos="flip-up">
          <img src="https://cdn.svgporn.com/logos/css-3.svg" alt="" />
          <h3>CSS</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/512px-HTML5_logo_and_wordmark.svg.png"
            alt=""
          />
          <h3>HTML</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img src="https://cdn.svgporn.com/logos/redux.svg" alt="" />
          <h3>Redux</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img src="https://github.com/chakra-ui.png" alt="" />
          <h3>Chakra UI</h3>
        </div>
      </div>

      <br></br>
      <br></br>
      <h2 data-aos="fade-down">Back-End & Database</h2>
      <div class="skills-div">
        <div class="skills-card" data-aos="flip-up">
          <img
            src=" https://cdn4.iconfinder.com/data/icons/google-i-o-2016/512/google_firebase-2-256.png"
            alt=""
          />
          <h3>Firebase</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://cdn.icon-icons.com/icons2/2415/PNG/512/mongodb_original_wordmark_logo_icon_146425.png"
            alt=""
          />
          <h3>MongoDB</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRNvlAM2kg5H1ufCzBW7GjzCo77Ys_neYxOHQ&usqp=CAU"
            alt=""
          />
          <h3>ExpressJS</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://miro.medium.com/max/512/1*fVBL9mtLJmHIH6YpU7WvHQ.png"
            alt=""
          />
          <h3>Postman</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://cdn.freebiesupply.com/logos/large/2x/nodejs-icon-logo-png-transparent.png"
            alt=""
          />
          <h3>Node</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png"
            alt="git"
          />
          <h3>Git</h3>
        </div>
        <div class="skills-card" data-aos="flip-up">
          <img
            src="https://cdn-icons-png.flaticon.com/512/25/25231.png"
            alt="github"
          />
          <h3>Github</h3>
        </div>
      </div>
      <br></br>
      <br></br>
    </section>
  );
}
